import { collection, onSnapshot, doc, deleteDoc, writeBatch, Timestamp } from 'firebase/firestore';
import { db } from './firebase-init';

// Events imported from .ics files. Stored separately from jobs — they're
// reference entries on the calendar (meetings, deliveries, etc.), not work.
const COLLECTION = 'calendarEvents';

// Doc id comes from the event's UID so importing the same file twice updates
// the existing entries instead of duplicating them.
function eventDocId(event) {
  const key = event.uid || `${event.title}-${event.start.getTime()}`;
  return key.replace(/[^A-Za-z0-9_.@-]/g, '_').slice(0, 300);
}

export function subscribeToCalendarEvents(callback) {
  return onSnapshot(collection(db, COLLECTION), snapshot => {
    callback(snapshot.docs.map(d => {
      const data = d.data();
      return {
        id: d.id,
        ...data,
        start: data.start?.toDate(),
        end: data.end?.toDate(),
      };
    }));
  }, error => {
    console.error('❌ Calendar events listener error:', error);
  });
}

export async function importCalendarEvents(events, fileName) {
  const now = Timestamp.now();
  // Firestore batches cap at 500 writes.
  for (let i = 0; i < events.length; i += 450) {
    const batch = writeBatch(db);
    events.slice(i, i + 450).forEach(event => {
      batch.set(doc(db, COLLECTION, eventDocId(event)), {
        uid: event.uid,
        title: event.title,
        start: Timestamp.fromDate(event.start),
        end: Timestamp.fromDate(event.end),
        allDay: event.allDay,
        location: event.location,
        description: event.description,
        sourceFile: fileName || '',
        importedAt: now,
      });
    });
    await batch.commit();
  }
}

export async function deleteCalendarEvent(id) {
  await deleteDoc(doc(db, COLLECTION, id));
}
